import { forbidOnGateDisabled } from '~/components/Builder/Common/CreationLimitations/commonActionBlockLimitation';
import {
    LimitationProps,
    AsAllowed
} from '~/components/Builder/Common/CreationLimitations/creationLimitations.types';

export const forbidCanvablockOnIntegrationGateDisabled = ({
    sourceBlock
}: LimitationProps<'sourceBlock'>) => {
    // @ts-ignore
    if (sourceBlock?.isCanvaBlock) {
        return forbidOnGateDisabled('canva_integration');
    }

    return AsAllowed;
};
